import { FormEvent, useState } from "react";
import { Button, Col, Form, Modal, Nav, OverlayTrigger, Popover, Row } from "react-bootstrap";
import removeAllErrorMsg from "../../components/funcRemoveAllErros";
import { getCookie } from "../../config/cookies";
import { ApiEndpoints, reqPostDownloadFile } from "../../config/apiClient";
import { toast } from "react-toastify";
import dayjs from "dayjs";

function ModalCnvImportar({ show, handleClose }:iProps) {
    const [loading, setLoading] = useState<boolean>(false)
    const resultadosReset = { cnvs: [], colaboradores: [] }
    const [resultados, setResultados] = useState<any>(resultadosReset)
    const [mostrarResultados, setMostrarResultados] = useState<boolean>(false)
    const [mostrarDemitidos, setMostrarDemitidos] = useState<boolean>(false)
    const [menu, setMenu] = useState<MenuItem[]>([
        {
            key: "dados_basicos",
            link: "link-0",
            visibled: true,
            display: "block"
        },
        {
            key: "funcionario",
            link: "link-1",
            visibled: false,
            display: "none"
        },
    ])

    function handleSubmit(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        event.stopPropagation()

        removeAllErrorMsg()

        const form:any = event.target
        let formValidado = true
        let dadosImportar = {
            planilha: form.planilha.files,
        }
        console.log(dadosImportar)
        if (dadosImportar.planilha.length === 0) {
            form.planilha.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (!formValidado) {
            return
        }
        importar(dadosImportar)
    }

    async function importar(dadosImportar:any) {
        setLoading(true)

        const token = getCookie("token")
        const id_usuario = getCookie("id_user")
        let dados = new FormData()
        dados.append('planilha', dadosImportar.planilha[0])

        try {
            let api:Response
            let apiData = await fetch(
                ApiEndpoints.importarPlanilhaCnvColaboradores.endpoint,
                {
                    method: "PATCH",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "id_usuario": id_usuario,
                    },
                    body: dados
                }
            ).then(response => {
                api = response
                return response.json()
            })
            if (api!.status === 200) {
                console.log(apiData)
                toast.success("Importação finalizada com sucesso!", {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
                setMostrarResultados(true)
                setResultados(apiData)
            } else {
                setMostrarResultados(false)
                setResultados(resultadosReset)
                toast.warn(String(apiData.message), {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            }
        } catch (error) {
            setMostrarResultados(false)
            setResultados(resultadosReset)
            console.log(error)
            toast.warn('Não foi possível importar, verifique se o layout está correto ou contate o suporte!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }

        setLoading(false)
    }

    function handleSubmitRelatorio(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        event.stopPropagation()
        removeAllErrorMsg()

        const form:any = event.target
        let formValidado = true
        let dados = {
            mostrar_demitidos: form.mostrar_demitidos.value === "true" ? true : false,
            qtd_dias: form.qtd_dias.value,
        }
        console.log(dados)
        if (dados.qtd_dias === "" || Number(dados.qtd_dias) === 0) {
            form.qtd_dias.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (!formValidado) {
            return
        }

        dados.qtd_dias = Number(dados.qtd_dias)

        download(dados)
    }

    async function download(dados:any) {
        setLoading(true)
        let arquivo:string = `Relatorio-Situacao-CNV-${dayjs().format("DD-MM-YYYY")}.pdf`
        let response = await reqPostDownloadFile(ApiEndpoints.importarPlanilhaCnvColaboradoresDownload, dados, arquivo)
        if (response.status === 200) {
            toast.success('Aguarde o termino do download...', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        } else {
            toast.error('Erro no download, tente mais tarde ou verifique com o suporte!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }
        setLoading(false)
    }

    const popover = (
        <Popover id="popover-basic" style={{minWidth: "600px"}}>
            <Popover.Header as="h3">Exemplo Layout (Colunas)</Popover.Header>
            <Popover.Body>
                <Row>
                    <Col className="col-12">
                        <p><b>Tipo do arquivo*:</b> .xlsx</p>
                        <p><b>CPF*:</b> 123.456.789-00 (texto)</p>
                        <p><b>Nome*:</b> Nome e Sobrenome (texto)</p>
                        <p><b>Número CNV*:</b> 12345 / 6789 (texto)</p>
                        <p><b>Data último curso*:</b> 01/01/1999 (data)</p>
                        <p><b>Data de Validade da CNV*:</b> 01/01/1999 (data)</p>
                        <p>Outras colunas serão desconsideradas.</p>
                        <br/>
                        <p><b>Obs.:</b> Não é necessário estar na ordem acima, as colunas precisam apenas existir na planilha com o mesmo nome, caso faltar 1 ou mais, a importação não será realizada.</p>
                    </Col>
                </Row>
            </Popover.Body>
        </Popover>
    )

    const handleMenuItemClick = (e:any) => {
        const index = Number(e.target.getAttribute('tabindex'))
        let menuItems = menu

        if (e.ctrlKey) {
            let item :MenuItem = menuItems[index]
            item.display = item.display === "none" ? "block" : "none"
            item.visibled = item.visibled === false ? true : false
            document.getElementById(item.key)!.style.display = item.display
            if (item.visibled) {
                document.getElementById(item.link)!.classList.add('active')
            } else {
                document.getElementById(item.link)!.classList.remove('active')
            }
            menuItems[index] = item
            setMenu(menuItems)
        } else {
            renderizarSubMenus(menuItems, index)
        }
    }

    function renderizarSubMenus(menuItems:MenuItem[], index:number) {
        for (let i in menuItems) {
            if (Number(i) === index) {
                let item :MenuItem = menuItems[index]
                if (item.visibled) {
                    continue
                }
                item.display = item.display === "none" ? "block" : "none"
                item.visibled = item.visibled === false ? true : false
                document.getElementById(item.key)!.style.display = item.display
                if (item.visibled) {
                    document.getElementById(item.link)!.classList.add('active')
                } else {
                    document.getElementById(item.link)!.classList.remove('active')
                }
                menuItems[index] = item
            } else {
                let item :MenuItem = menuItems[i]
                item.display = "none"
                item.visibled = false
                document.getElementById(item.key)!.style.display = item.display
                if (item.visibled) {
                    document.getElementById(item.link)!.classList.add('active')
                } else {
                    document.getElementById(item.link)!.classList.remove('active')
                }
                menuItems[i] = item
            }
        }
        setMenu(menuItems)
    }

    function handleChangeMostrarDemitidos(event:any) {
        console.log(event)
        if (event.target.value === 'true') {
            setMostrarDemitidos(true)
        } else if (event.target.value === 'false') {
            setMostrarDemitidos(false)
        }
    }

    const customStyleForRadioDiv:React.CSSProperties = {
        display: 'inline-flex',
        alignItems: 'center',
        margin: '0px 10px 0px 0px',
        padding: '0px'
    }

    const customStyleForRadioDivInput:React.CSSProperties = {
        padding: '0px',
        margin: '0px',
        cursor: 'pointer'
    }

    const customStyleForRadioDivLabel:React.CSSProperties = {
        padding: '2px 0px 0px 10px',
        margin: '0px',
        cursor: 'pointer'
    }

    return (
        <Modal
            id="modalImportarCnv"
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>Importar planilha de CNV</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Nav variant="tabs">
                    <Nav.Item>
                        <Nav.Link id="link-0" onClick={handleMenuItemClick} href='' tabIndex={0} active={menu[0].visibled} >Importar</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link id="link-1" onClick={handleMenuItemClick} href='' tabIndex={1} active={menu[1].visibled} >Relatório</Nav.Link>
                    </Nav.Item>
                </Nav>
                <br></br>
                
                <div id={menu[0].key}>
                    <Form id={`formImportarCnv`} onSubmit={handleSubmit} noValidate>
                        <Row>
                            <Col className="col-12">
                                <Form.Group>
                                    <Form.Label>Arquivo:</Form.Label>
                                    <Form.Control type="file" name="planilha" id="planilha" aria-label="Selecione a Planilha" accept=".xlsx"></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        Selecione o arquivo!
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                        <br/>
                        <Button type="submit" disabled={loading} style={{marginRight: "10px"}}>{loading ? "Aguarde..." : "Importar"}</Button>

                        <OverlayTrigger trigger="click" placement="right" overlay={popover}>
                            <Button variant="success">Layout</Button>
                        </OverlayTrigger>
                    </Form>
                    
                    <br></br>
                    { mostrarResultados && <DivMostrarDadosImportados cnvs={resultados.cnvs} colaboradores={resultados.colaboradores} colaboradores_nao_encontrados={resultados.colaboradores_nao_encontrados} /> }
                </div>

                <div id={menu[1].key} style={{display: "none"}}>
                    <Form id={`formRelatorioCnv`} onSubmit={handleSubmitRelatorio} noValidate>
                        <Row>
                            
                            <Col className="col-6">
                                <Form.Group>
                                    <Form.Label>Informe quantidade de dias:</Form.Label>
                                    <Form.Control name='qtd_dias' type="number" id='qtd_dias' defaultValue={60} placeholder=""/>
                                    <Form.Control.Feedback type="invalid">
                                        Informe os dias!
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col className="col-6">
                            <Form.Group>
                                <Form.Label>Mostrar Colaboradores Demitidos:</Form.Label><br></br>
                                <div className="form-check" style={customStyleForRadioDiv}>
                                    <input className="form-check-input" type="radio" name="mostrar_demitidos" id="mostrar_demitidos_sim" value={'true'} style={customStyleForRadioDivInput} checked={mostrarDemitidos === true ? true : false} onChange={handleChangeMostrarDemitidos} />
                                    <label className="form-check-label" htmlFor="mostrar_demitidos_sim" style={customStyleForRadioDivLabel}>Sim</label>
                                </div>
                                <div className="form-check" style={customStyleForRadioDiv}>
                                    <input className="form-check-input" type="radio" name="mostrar_demitidos" id="mostrar_demitidos_nao" value={'false'} style={customStyleForRadioDivInput} checked={mostrarDemitidos === false ? true : false} onChange={handleChangeMostrarDemitidos} />
                                    <label className="form-check-label" htmlFor="mostrar_demitidos_nao" style={customStyleForRadioDivLabel}>Não</label>
                                </div>
                            </Form.Group>    
                            </Col>

                        </Row>
                        <br/>
                        <Button type="submit" disabled={loading} style={{marginRight: "10px"}}>{loading ? "Aguarde..." : "Download"}</Button>
                    </Form>
                </div>
                
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )

}

interface iProps {
    show: boolean,
    handleClose: any,
}
interface MenuItem {
    key: string,
    link: string,
    visibled: boolean,
    display: string
}

export default ModalCnvImportar;

function DivMostrarDadosImportados({ cnvs, colaboradores, colaboradores_nao_encontrados }:iPropsDadosImportados) {
    return (
        <div>
            <h2>Importação realizada com sucesso!</h2>
            <p>Colaboradores atualizados: {colaboradores.length}</p>
            <p>Colaboradores total planilha: {cnvs.length}</p>
            <p>Não atualizados: {colaboradores_nao_encontrados.length}</p>
            {
                colaboradores_nao_encontrados.map((col, idx, dados) => {
                    return (
                        <div key={idx}>
                            <hr></hr>
                            <Row>
                                <div className="col-12">
                                    <p>Nome: {col.nome} - CPF {col.cpf}</p>
                                    <p>CNV Número: {col.cnv_numero_cnv}</p>
                                    <p>CNV Data atualizado: {dayjs(col.cnv_data_validade_cnv).format("DD/MM/YYYY HH:mm:ss")}</p>
                                    <p>CNV Data curso: {dayjs(col.cnv_data_ultimo_curso).format("DD/MM/YYYY HH:mm:ss")}</p>
                                </div>
                            </Row>
                        </div>
                    )
                })
            }
            <hr></hr>
            <hr></hr>
            {
                colaboradores.map((col, idx, dados) => {
                    return (
                        <div key={idx}>
                            <Row>
                                <div className="col-6">
                                    <p>Colaborador: {col.matricula} - {col.nome_completo}</p>
                                    <p>CNV Número: {col.cnv_numero}</p>
                                    <p>CNV Data atualizado: {dayjs(col.cnv_atualizado).format("DD/MM/YYYY HH:mm:ss")}</p>
                                    <p>Situação: {col.situacao} {col.id_situacao === 8 && `, ${dayjs(col.data_demissao).format("DD/MM/YYYY")}`}</p>
                                </div>
                                <div className="col-6">
                                    <p>Empresa: {col.empresa}</p>
                                    <p>CNV Data último curso: {dayjs(col.cnv_data_ultimo_curso).format("DD/MM/YYYY")}</p>
                                    <p>CNV Data validade: {dayjs(col.cnv_data_validade).format("DD/MM/YYYY")}</p>
                                    <p>Data admissão: {dayjs(col.data_admissao).format("DD/MM/YYYY")}</p>
                                </div>
                            </Row>
                            <a href={`/colaborador?id=${col.id_colaborador}`} target="_blank" rel="noreferrer">Acessar cadastro</a>
                            <hr></hr>
                        </div>
                    )
                })
            }
        </div>
    )
}
interface iPropsDadosImportados {
    cnvs: any[]
    colaboradores: any[]
    colaboradores_nao_encontrados: any[]
}